// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox'>;

const SvgIcoChevronRight = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M8 17.65 9.739 19 16 12 9.739 5 8 6.35 13.054 12z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);

export default SvgIcoChevronRight;
